module.exports = __webpack_public_path__ + "img/icon_round_chevron_right.31a8db95.svg";